export default __webpack_public_path__ + "static/media/6.2e2aab74.jpg";